import instance from '../../utils/API'
const axios = require('axios')

// Actions
const GET_PROFILE = 'redux/userProfile/GET_PROFILE'
const GET_PROFILE_ERROR = 'redux/userProfile/GET_PROFILE_ERROR'
const GET_PROFILE_SUCCESS = 'redux/userProfile/GET_PROFILE_SUCCESS'


// Reducer
const initialState = {
    firstName: "",
    lastName: "",
    country: "",
    phoneNumber: "",
    avatarUrl: "",
    subscriptionUntill: null,
    odinMember: false,
    isFetching: false,
    isError: false,
    profileError: null
}
const userProfile = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILE_SUCCESS:
            return {
                ...state,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                country: action.payload.country, 
                phoneNumber: action.payload.phoneNumber, 
                avatarUrl: action.payload.avatarUrl, 
                subscriptionUntill: action.payload.subscriptionUntill,
                odinMember: action.payload.odinMember,
                isFetching: false,
                profileError: null
            }
        
        case GET_PROFILE:
            return {
                ...state,
                isFetching: true,
                profileError: null
            }

        case GET_PROFILE_ERROR:
            return {
                ...state,
                isFetching: false,
                isError: true,
                profileError: action.payload
            }
        default:
            return state
    }
}

export default userProfile
const getProfile = (access_token) => dispatch  => {

    dispatch({
        type: GET_PROFILE
    })

    instance(access_token).get("users/me",{})
        .then(function (response) {
            if (response.data) {
            dispatch({
                type: GET_PROFILE_SUCCESS,
                payload: response.data
            })
        }
        })
        .catch(function (error) {
            let errMsg = "Network Error"
            if(error.response){
                errMsg = error.response
            }
            dispatch({
                type: GET_PROFILE_ERROR,
                payload: errMsg
            })

        })
}

export const profileActions = {
    getProfile,
}
